import { trim } from 'lodash';
import store from '@/store/index';
export default function permission(paths, action) {
  let navs = store.getters.navs;
  let navnode;
  for (let i = 0; i < paths.length; i++) {
    const element = paths[i];
    if (i == 0) {
      navnode = findNav(element, navs);
    } else {
      navnode = findNav(element, navnode.children);
    }
    if (navnode) {
      if (i == paths.length - 1) {
        if (action == '') {
          return true;
        }
        const actions = navnode.meta ? navnode.meta.action || [] : [];
        return actions ? actions.includes(action) : false;
      }
    } else {
      return false;
    }
  }
  return false;
}

const findNav = (path, nav) => {
  for (const i of nav) {
    if (trim(i.path, '/') == path) {
      return i;
    }
  }
  return null;
};
